const toUrlFriendlyString = (str: string) =>
  str
    .toLowerCase() // Convert to lowercase
    .replace(/[^a-z0-9\s]/g, '') // Remove non-alphanumeric characters
    .trim() // Trim whitespace from both sides
    .replace(/\s+/g, '-'); // Replace spaces with hyphens

export default toUrlFriendlyString;
